/**
 * ID Generator Utilities
 */

export function generateCredentialId(settings, index) {
  const numStr = String(index + 1).padStart(settings.idLength || 4, '0');
  return `${settings.idPrefix}-${settings.idYear}-${numStr}`;
}

export function generateVerificationId(mode = 'CERT') {
  const ts = Date.now().toString(36).toUpperCase();
  const rand = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `VER-${mode}-${ts}-${rand}`;
}

export function generateApplicationId() {
  const rand = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `APP-${new Date().getFullYear()}-${rand}`;
}

export const ID_KEYS = [
  'intern id', 'internid', 'intern_id', 'internship id', 'internship_id',
  'credential id', 'credential_id', 'candidate id', 'candidate_id',
  'student id', 'student_id', 'roll no', 'roll_no', 'reg no', 'reg_no',
  'id', 'certificate id', 'cert id'
];

/**
 * Robustly extract Intern ID from a parsed CSV/Excel row.
 * Handles explicit headers ("Intern ID", "Candidate ID", etc.)
 * as well as unlabelled/auto-generated headers like "__EMPTY" or "Column1"
 * where the cell contains an ID like "IH-FS-2026-0599".
 */
export function extractInternId(row, headers = []) {
  if (!row) return null;

  // 1. Direct header lookup matching ID_KEYS
  for (const h of headers) {
    if (ID_KEYS.includes(h.toLowerCase().trim())) {
      const val = String(row[h] || '').trim();
      if (val) return val;
    }
  }

  // 2. Direct property lookup matching ID_KEYS
  for (const key of Object.keys(row)) {
    const cleanKey = key.toLowerCase().trim();
    if (ID_KEYS.includes(cleanKey)) {
      const val = String(row[key] || '').trim();
      if (val) return val;
    }
  }

  // 3. Fallback: inspect unlabelled/auto-generated Excel headers like __EMPTY
  for (const key of Object.keys(row)) {
    if (key.startsWith('_') && key !== '__EMPTY' && !key.startsWith('__EMPTY_')) {
      continue;
    }
    const val = String(row[key] || '').trim();
    if (
      /^(IH|INT|CERT|FS|AI|DS|ML)[-_]/i.test(val) ||
      /^[A-Z0-9]{2,6}[-_][A-Z0-9]{2,6}[-_][A-Z0-9]{2,10}/i.test(val)
    ) {
      return val;
    }
  }

  return null;
}
